import type {CommandSearchContext} from '../types';

export type RecentActionHandlerResult = void | boolean | Promise<void | boolean>;

export type RecentActionHandler = (
    payload: Record<string, string | number | boolean | undefined>,
    ctx: CommandSearchContext,
) => RecentActionHandlerResult;

const handlers = new Map<string, RecentActionHandler>();

/** Registers a handler invoked when a recent entry with the given actionKey is replayed. */
export const registerRecentActionHandler = (actionKey: string, handler: RecentActionHandler): void => {
    handlers.set(actionKey, handler);
};

/** Removes a registered recent action handler. */
export const unregisterRecentActionHandler = (actionKey: string): void => {
    handlers.delete(actionKey);
};

/** Replays a stored recent action via the registered handler registry. */
export const replayRecentAction = (
    actionKey: string,
    payload: Record<string, string | number | boolean | undefined>,
    ctx: CommandSearchContext,
): RecentActionHandlerResult => handlers.get(actionKey)?.(payload, ctx);

/** Clears all registered handlers (useful in tests). */
export const clearRecentActionHandlers = (): void => {
    handlers.clear();
};
